import { render, staticRenderFns } from "./PrivacyPolicyHeader.vue?vue&type=template&id=6e6945eb&scoped=true&"
import script from "./PrivacyPolicyHeader.vue?vue&type=script&lang=js&"
export * from "./PrivacyPolicyHeader.vue?vue&type=script&lang=js&"
import style0 from "./PrivacyPolicyHeader.vue?vue&type=style&index=0&id=6e6945eb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e6945eb",
  null
  
)

export default component.exports